/**
 * TestModeBanner Component
 * 
 * Displays a visible "MODO PRUEBA" banner when the application
 * is running in WebPay integration/test environment.
 * 
 * Requirements: 10.4
 */

import { AlertTriangle } from 'lucide-react';
import { isTestMode } from '../services/paymentApi';

/**
 * TestModeBanner Component
 * 
 * Shows a fixed banner at the top of the page when in test mode.
 * The banner is visible on all pages to clearly indicate that
 * payments are being processed in the sandbox environment.
 * 
 * @returns {JSX.Element|null} - Banner element or null if in production
 */
export default function TestModeBanner() {
  // Only show banner in test/integration mode
  if (!isTestMode()) {
    return null;
  }

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-amber-500 to-orange-500 text-white py-2 px-4 shadow-lg"
      role="alert"
      aria-live="polite"
    >
      <div className="container mx-auto flex items-center justify-center gap-2 text-sm font-semibold">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
        <span>MODO PRUEBA - Los pagos no son reales</span>
        <span className="hidden sm:inline">
          | Tarjeta de prueba: 4051 8856 0044 6623
        </span>
      </div>
    </div>
  );
}
